<template>
  <v-dialog v-model="showDialog" persistent max-width="600px" style="z-index: 1001 !important;">
    <v-card>
      <v-card-title class="d-flex align-center text-h5">
        <span>Review & Agree</span>
      </v-card-title>
      <v-card-text>
        <div class="mb-3">
          <div class="text-subtitle-1 font-weight-bold">Terms of Use</div>
          <a :href="`https://${ appDomain }/termsofuse.html`" target="_blank">Click here to view</a>
        </div>
        <div class="mb-3">
          <div class="text-subtitle-1 font-weight-bold">Privacy Policy</div>
          <a :href="`https://${ appDomain }/privacy.html`" target="_blank">Click here to view</a>
        </div>

        <div v-if="shouldAskForMarketingAndFeedback">
          <b>Receive emails about new features and discounts? *</b>
          <v-radio-group v-model="marketing" inline hide-details>
            <v-radio label="yes" value="yes" color="accent" />
            <v-radio label="no" value="no" class="ml-2" color="accent" />
          </v-radio-group>
          <v-alert density="compact" :type="marketing === 'yes' ? 'success' : 'error'" class="mt-2" v-if="shouldOfferDiscount && marketing !== null && $store.state.account && $store.state.account.account && $store.state.account.account.createdTimestamp && $store.state.account.account.createdTimestamp > Date.now() - 7 * 24 * 60 * 60 * 1000 && $store.state.inApp">
            <template v-if="marketing === 'yes'">
              Check your email inbox for a $3 discount code!
            </template>
            <template v-else>
              You won't receive an immediate $3 discount code.
            </template>
          </v-alert>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="decline()" variant="outlined" color="secondary" :disabled="accepting">Decline</v-btn>
        <v-spacer />
        <v-btn variant="elevated" @click="accept()" color="primary" :disabled="accepting || marketing === null" :loading="accepting">
          Agree
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import StoreConstants from '../StoreConstants'
import api from '../lib/api'
import auth from '../lib/auth'

  const shouldAskForMarketingAndFeedback = true
  const shouldOfferDiscount = process.env.VUE_APP_PRODUCT === 'truple'

  export default {
    name: "TermsOfService",
    data () {
      return {
        appName: process.env.VUE_APP_NAME,
        appDomain: process.env.VUE_APP_DOMAIN,
        accepting: false,
        shouldAskForMarketingAndFeedback: shouldAskForMarketingAndFeedback,
        shouldOfferDiscount: shouldOfferDiscount,
        marketing: null,
        feedback: 'yes'
      }
    },
    methods: {
      async accept() {
        try {
          this.accepting = true

          let marketingBool = this.marketing === 'yes' ? true : false
          let feedbackBool = this.feedback === 'yes' ? true : false

          let success = await api.acceptTerms(marketingBool, feedbackBool)
          let accountResponse = await api.getAccountAwait(true)

          this.$store.commit(StoreConstants.commits.setAccount, accountResponse.data)
          this.$store.commit(StoreConstants.commits.setTermsAccepted)
        } catch(error) {
          console.log(error)
          this.$swal(`Error accepting terms, please email support@${process.env.VUE_APP_DOMAIN} for help.`)
        } finally {
          this.accepting = false
        }
      },
      async decline() {
        let val = await this.$swal({
          title: 'Decline',
          text: `Do you wish to decline and logout from ${this.appName}?`,
          showCancelButton: true
        })

        if(val.isConfirmed) {
          await auth.logoutAwait('terms-declined', undefined, { userInitiated: true })
          location.reload()
        }
      }
    },
    computed: {
      show() {
        return !this.$store.getters.termsAccepted
      },
      showDialog: {
        get() {
          return this.show
        },
        set() {
          //do nothing
        }
      }
    }
  }
</script>

<style scoped>

</style>
